// @flow

/**
 * Chart colour palette for data display components.
 * Derived from the existing theme's chart widget line/bar colours
 * to ensure visual consistency with report widgets.
 */

const CHART_PALETTE: string[] = [
  '#2965CC',
  '#29A634',
  '#D99E0B',
  '#D13913',
  '#8F398F',
  '#00B3A4',
  '#DB2C6F',
  '#9BBF30',
  '#96622D',
  '#7157D9',
];

/**
 * Get a colour for a series by index.
 * Wraps around if index exceeds palette size.
 */
export function getSeriesColour(index: number): string {
  return CHART_PALETTE[index % CHART_PALETTE.length];
}
